/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { ObjectAttributeArgs } from 'cio/components/campaigns/trigger/setup/condition-blocks/object/config';
import operators from 'cio/utils/operators';
import { SerializedLegacyObjectAttributeFilter } from 'cio/types/conditions/legacy-filter';

interface ConditionBlockObjectArgs extends ObjectAttributeArgs {
  isRequired: boolean;
  isObjectRelationshipCampaignType?: boolean; // "Object Relationship" trigger type have no required criteria
  columnCount: number;
  openSidebarOnMountEmpty?: boolean;
  onSidebarClose?: (hasConditions: boolean) => unknown;
}

export default class ConditionBlockObject extends Component<ConditionBlockObjectArgs> {
  get objectAttributes() {
    return this.args.objectAttributes ?? [];
  }

  get highlight() {
    return this.objectAttributes.length === 0;
  }

  get attributeCount() {
    return this.objectAttributes.length;
  }

  get cutThreshold() {
    let { maxSegmentCountBeforeThreshold } = this.args;
    // if more than threshold, then we show "threshold minus 1" attributes and "x more"
    if (this.attributeCount > maxSegmentCountBeforeThreshold) {
      return maxSegmentCountBeforeThreshold - 1;
    }
    return maxSegmentCountBeforeThreshold;
  }

  get cuttedOffCount() {
    return this.attributeCount - this.cutThreshold;
  }

  get operatorLabels() {
    return this.objectAttributes.map(
      ({ operator }: SerializedLegacyObjectAttributeFilter) =>
        operators.find(({ value }) => value === operator)?.label ?? '',
    );
  }

  @action
  onSidebarClose(sidebarWasVisible: boolean) {
    if (this.args.onSidebarClose != null && sidebarWasVisible === true && this.args.openSidebarOnMountEmpty === true) {
      this.args.onSidebarClose(!this.highlight);
    }
  }
}
